import { partsFromPageKey, addressFromPageKey } from 'common/logic'
import { ExternalLinkIcon } from 'cc/icons'

const DataRow = ({ label, value }) => {
  if (!value) return null

  return (
    <tr className="">
      <th className="text-gray-500 font-light align-top pr-3 text-right pt-[2px]">{label}</th>
      <td className="font-mono text-gray-700 break-all align-top">{value}</td>
    </tr>
  )
}

const PageReviewDataTable = ({ domainKey, pageKey }) => {
  if (!pageKey) return null
  const { path, subdomain } = partsFromPageKey(pageKey)

  // TODO: maybe viaHttp, viaWww?
  const url = addressFromPageKey({ domainKey, pageKey })
  return (
    <table className="table-auto">
      <tbody>
        <DataRow label="Domain" value={domainKey} />
        <DataRow
          label="Path"
          value={
            <div className="flex items-start">
              {path}{' '}
              <ExternalLinkIcon
                href={url}
                className="ml-1 text-xl"
                title="External page"
                rel="nofollow noopener noreferrer"
                target="_blank"
              />
            </div>
          }
        />
        <DataRow label="Subdomain" value={subdomain} />
      </tbody>
    </table>
  )
}

export default PageReviewDataTable
